<template>
    <div class="projects-work">
        <div class="works">
            <h1>Projects</h1>
            <div class="projects">
                <div class="project">
                    <div class="img">
                        <img src="../assets/leavemanagementsystem.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Leave Management System</h1>
                        <p>Just a simple leave management system. I also integrated a sms gateway for this application. Every approve and decline leave files it will send an sms notification for the specific employee. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, <strong>Laravel</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/LeaveManagementSystem" target="_blank">View Code</a>
                    </div>
                </div>
                <div class="project reverse">
                    <div class="title">
                        <h1>Plotter Scheduler with TimeTable</h1>
                        <p>This project is also developed during my internship. This is the first task that is given to me before <strong>Online Item Requisition & Management</strong>, but suddenly stop because of the other task has been given to us and that's <strong>Online Item Requisition & Management</strong>. I know Plotter Scheduler has a big impact to view your schedule more visibility with time grid so I continue developing this project. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/Plotter-Scheduling" target="_blank">View Code</a>
                    </div>
                    <div class="img">
                        <img src="../assets/scheduler.png" alt="">
                    </div>
                </div>
                <div class="project">
                    <div class="img">
                        <img src="../assets/requisition.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Online Item Requisition & Management</h1>
                        <p>This system application is made during my internship in <strong>Cebu Technological University - Danao Campus</strong>. This is made to manage items in supply office and teachers items. Students, Teachers and Faculties has their own account to borrow items from a specific owner or direct to the supply items. We used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>Flask</strong>, and <strong>MSSQL</strong>.</p>
                        <a type="button" target="_blank" style="cursor: pointer;">Confidential</a>
                    </div>
                </div>
                <div class="project reverse">
                    <div class="title">
                        <h1>Centrum Reservation System Management</h1>
                        <p>This system application is my Capstone Thesis Project. Basically this system is only admin panel, that only manage who are booked and reserved for a specific day. I integrated also FullCalendar for better view of reservations. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>jQuery</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>.</p>
                        <a type="button" target="_blank" style="cursor: pointer;">Confidential</a>
                    </div>
                    <div class="img">
                        <img src="../assets/reservation.png" alt="">
                    </div>
                </div>
                <div class="project">
                    <div class="img">
                        <img src="../assets/order-tracker.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Order Tracker with RealTime Deliver Status</h1>
                        <p>Just a simple food application that can track users order realtime. I learn WebSockets at this point. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>PHP</strong>, <strong>Laravel</strong>, <strong>Pusher WebSockets</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/SimpleOrderTracker" target="_blank">View Code</a>
                    </div>
                </div>
                <div class="project reverse">
                    <div class="title">
                        <h1>Fancy Merch Apparel</h1>
                        <p>This Application is a school activity for Professional Elective Web Application. We've been instructed to make Web Application using Laravel for the Finals. Just a simple Merch application that you can buy add and add to cart, maybe soon I'll add stripe for the payment. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Bootstrap</strong>, <strong>Javascript</strong>, <strong>PHP</strong>, <strong>Laravel</strong>, <strong>Livewire</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/FancyMerchApparel" target="_blank">View Code</a>
                    </div>
                    <div class="img">
                        <img src="../assets/merch.png" alt="">
                    </div>
                </div>
                <div class="project">
                    <div class="img">
                        <img src="../assets/inventory-system.png" alt="">
                    </div>
                    <div class="title">
                        <h1>Inventory System Management</h1>
                        <p>This is my ever first application I've created in school. It is an activity that is related to Information System, and we're instruct to build a application or system that is integrated to Database. I used <strong>HTML</strong>, <strong>CSS</strong>, <strong>Javascript</strong>, <strong>PHP</strong>, and <strong>MySQL</strong>.</p>
                        <a href="https://github.com/ronnin01/Inventory-System" target="_blank">View Code</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>